import { FC, Suspense } from 'react'
import { GraphMapWidgetContent } from 'src/v2/views/owner-reveal/insights/owner-graph-map/graph-map-widget/content'
import { FlowTree } from '@emotion-icons/entypo/FlowTree'
import { Insight } from 'src/components/insights/types'
import { AlphamapLogoThrobber } from 'src/components/alphamap-logo/throbber'
import styled from '@emotion/styled'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'

const LoadingContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const GraphMapWidget: FC = () => {
  return (
    <Suspense
      fallback={
        <LoadingContainer>
          <AlphamapLogoThrobber />
        </LoadingContainer>
      }>
      <GraphMapWidgetContent />
    </Suspense>
  )
}

export const GraphMapInsight: Insight = {
  id: 'graph-map',
  tabId: COMMANDAI_IDS_MAP.ownerReveal['graph-map-tab'],
  name: 'Graph Map',
  icon: FlowTree,
  component: GraphMapWidget,
  linkTooltipFile: 'graph-map',
  supportedResultTypes: ['owner'],
}
